<template>
  <svg
    class="password-visibility-icon"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <template v-if="!visible">
      <circle cx="12" cy="12" r="2.5" />
      <path d="M2.5 12s3.5-5.5 9.5-5.5 9.5 5.5 9.5 5.5-3.5 5.5-9.5 5.5S2.5 12 2.5 12Z" />
    </template>
    <template v-else>
      <path d="m3.5 3.5 17 17" />
      <path d="M10.2 6.7c.6-.1 1.2-.2 1.8-.2 6 0 9.5 5.5 9.5 5.5a15.2 15.2 0 0 1-3.2 3.7" />
      <path d="M15.6 17c-1.1.3-2.3.5-3.6.5-6 0-9.5-5.5-9.5-5.5a15 15 0 0 1 3.4-3.9" />
      <path d="M10.3 10.3a2.5 2.5 0 0 0 3.4 3.4" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'PasswordVisibilityIcon',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.password-visibility-icon {
  display: block;
  width: 19px;
  height: 19px;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
